import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useExternalLinks } from '@/app/hooks/useExternalLinks';
import { eventTracking } from '@/services/event-tracking';

import { ICard } from '../types';

const useMobileAppCard = (): ICard[] => {
  const intl = useIntl();
  const links = useExternalLinks();

  return useMemo(
    () => [
      {
        id: 'download',
        cardStatus: 'todo',
        title: intl.formatMessage({
          defaultMessage: 'Your account is now active',
          id: '193cX3',
          description: 'todo list app card title',
        }),
        desc: intl.formatMessage({
          defaultMessage: 'Download the Wheely app for Chauffeurs to start your first journey.',
          id: 'iTHR1Y',
          description: 'todo list app card tip',
        }),
        actionTitle: intl.formatMessage({
          defaultMessage: 'OPEN THE APP',
          id: 'U9FVkJ',
          description: 'todo list app card action',
        }),
        actionTracker: () => {
          eventTracking.trackSnowplow({
            event: 'Onboarding - App - Open',
          });
        },
        actionExternalLink: links.downloadDriverApp,
        order: -1000,
        isExcludedFromProgress: true,
      },
    ],
    [intl, links.downloadDriverApp],
  );
};

export { useMobileAppCard };
